import {
  insertEmoji,
  runEditorCommand,
} from "@/components/app/editor-v3/commands";
import { EDITOR_MEDIA_TAB } from "@/components/app/editor-v3/constants";
import { useEditorFieldContext } from "@/components/app/editor-v3/editor-context";
import { EmojiSelector } from "@/components/shared/emoji-selector";
import { useIsClient } from "@/hooks/use-is-client";

export const EditorEmojiPicker = () => {
  const {
    getEditorInstance,
    setEditorValue,
    editorContext: { activeMediaTab },
  } = useEditorFieldContext<"body">();
  const isClient = useIsClient();

  if (!isClient || activeMediaTab !== EDITOR_MEDIA_TAB.Emoji) {
    return null;
  }

  return (
    <EmojiSelector
      onEmojiClick={(data) => {
        try {
          const view = getEditorInstance("prosemirror");

          if (runEditorCommand(view, insertEmoji(data.emoji))) {
            return;
          }
        } catch {
          // Fall back to the legacy markdown-string append below.
        }

        setEditorValue((prev) => `${prev}${data.emoji}`);
      }}
    />
  );
};
